import { link } from 'fs'

export type NodeData = {
  id: string
  svg: any
  label: string
  info: any
  nodeType: string
}

export type SearchData = {
  id: string
  nodeType: string
  label: string
  info: any
}

export const GrafoConfig = {
  automaticRearrangeAfterDropNode: false,
  collapsible: false,
  directed: true,
  focusAnimationDuration: 0.75,
  focusZoom: 10,
  focusZoomToFit: true,
  focusZoomToFitOnClick: true,
  focusZoomToFitOnClickDelay: 1000,
  focusHighlightBehavior: true,
  highlightDegree: 0.5,
  highlightOpacity: 0.5,
  linkHighlightBehavior: false,
  maxZoom: 5,
  minZoom: 0.1,
  nodeHighlightBehavior: true,
  panAndZoom: false,
  staticGraph: false,
  staticGraphWithDragAndDrop: false,
  initialZoom: 3.8,
  d3: {
    alphaTarget: 0.05,
    gravity: -40,
    linkStrength: 2,
    disableLinkForce: false,
  },
  node: {
    color: '#000',
    fontColor: 'black',
    fontSize: 4,
    labelProperty: (node: NodeData) => {
      return node.label
    },
    fontWeight: 'normal',
    highlightFontSize: 4.5,
    highlightFontWeight: 'bold',
    mouseCursor: 'pointer',
    opacity: 1,
    renderLabel: true,

    size: 210,
    strokeColor: 'none',
    strokeWidth: 0.5,
    svg: '',
    symbolType: 'circle',
    // labelPosition: 'top',
  },
  link: {
    color: '#000',
    fontColor: 'black',
    fontSize: 3,
    fontWeight: 'normal',
    highlightColor: 'SAME',
    highlightFontSize: 8,
    highlightFontWeight: 'normal',
    mouseCursor: 'pointer',
    opacity: 1,
    renderLabel: true,
    semanticStrokeWidth: false,
    strokeWidth: 0.5,
    markerHeight: 6,
    markerWidth: 6,
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: 'butt',
    // type: 'CURVE_SMOOTH',
    type: 'STRAIGHT',
  },
}
